<template>
  <Loading v-if="is_loading" class="static" />
  <div v-else class="post-wrap">
    <div class="inner">
      <header class="post-header">
        <h2 v-html="post.title.rendered"></h2>
        <time>{{date_str}}</time>
        <p v-if="post.related_festival && post.related_festival.post_title">
          <router-link :to="'/festival/'+post.related_festival.post_name">
            Part of {{post.related_festival.post_title}}
          </router-link>
        </p>
        <p v-else>Exhibition</p>
        <p v-if="post.book_price" v-html="post.book_price"></p>

        <Button v-if="event_is_end">This exhibition has ended</Button>
        <Button v-else-if="post.book_text && !post.book_link">{{post.book_text}}</Button>
        <Button v-else-if="post.book_text && post.book_link" :link_url="post.book_link">{{post.book_text}}</Button>
      </header>

      <figure class="featured-image image" v-if="post.featured_image">
        <img :src="post.featured_image.url"  v-images-loaded:on.progress="imageLoaded">
        <figcaption v-if="post.featured_image.alt" v-html="post.featured_image.alt" ref="featured_caption"></figcaption>
      </figure>

      <Content>
        <Link class="membership-link" v-if="$store.state.link && $store.state.text" :post_link="$store.state.link">{{$store.state.text}}</Link>
        <div class="box" v-html="post.content.rendered"></div>
      </Content>
    </div>
    <div class="sections"  v-if="post.sections && post.sections.length !== 0">
      <EventSections v-for="(item, index) in post.sections" :key="'top-'+index" :data="item" :order="index" />

      <div class="buy-wrapper">
        <Button class="buy-button" v-if="post.book_text && !post.book_link">{{post.book_text}}</Button>
        <Button class="buy-button" v-else-if="post.book_text && post.book_link" :link_url="post.book_link">{{post.book_text}}</Button>
      </div>
    </div>
    <AlsoItems v-if="post.also_posts && post.also_posts.length !== 0" :items="post.also_posts" :festival="post.related_festival" />

    <RelatedGridItems v-if="post.related_posts && post.related_posts.length !== 0" :items="post.related_posts" />
  </div>
</template>

<script>
import GetPreviewUrl from '@/utils/GetPreviewUrl';
import RelatedGridItems from '@/components/RelatedGridItems.vue';
import Content from '@/components/ui/Content.vue';
import Button from '@/components/ui/Button.vue';
import Loading from '@/components/Loading.vue';
import EventSections from '@/components/EventSections.vue';
import FormatDate from '@/utils/FormatDate';
import imagesLoaded from 'vue-images-loaded';
import AlsoItems from '@/components/AlsoItems.vue';

export default {
    name: 'single-exhibition',

    directives: {
      imagesLoaded,
    },

    data () {
      return {
        post: false,
        is_loading: false,
        date_str: '',
        event_is_end: false,
      }
    },

    components: {
      Content,
      EventSections,
      RelatedGridItems,
      Loading,
      Button,
      AlsoItems,
    },

    props: {
      slug: {
        type: String,
        default: ''
      }
    },

    watch: {
      '$route.params': {
        handler(params) {
            // console.log(this.$route.name);
            this.fetchData(params);
        },
        immediate: true,
      }
    },

    methods: {
        fetchData() {
          let curr = new Date();
          curr = new Date(curr.getFullYear() + '-' + ('0' + (curr.getMonth() + 1)).slice(-2) + '-' + ('0' + curr.getDate()).slice(-2) + 'T00:00:00');
          let current_timestamp = parseInt(curr.getTime()/1000);

          this.is_loading = true;
          let api_obj = GetPreviewUrl('exhibitions', this.slug);


          this.$ajax.get(api_obj.url, api_obj.head).then(res => {
            document.title = 'Charleston — ' + this.decode(res.data[0].title.rendered);

            if (res.data[0].also_posts) {
              res.data[0].also_posts.forEach(item => {
                item.date_str = FormatDate(item);
              });
            }

            let item = res.data[0];
            let s = new Date(item.start_date_timestamp * 1000);
            let d = new Date(item.end_date_timestamp * 1000);

            s = s.getFullYear() + '-' + ('0' + (s.getMonth() + 1)).slice(-2) + '-' + ('0' + s.getDate()).slice(-2) + 'T00:00:00';
            d = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + 'T00:00:00';

            item.start_date_timestamp = (new Date(s).getTime()/1000);
            item.end_date_timestamp = (new Date(d).getTime()/1000);


            this.event_is_end = (item.thetype !== '1' && item.thetype !== '2' && item.end_date_timestamp < current_timestamp);

            this.post = res.data[0];
            this.is_loading = false;
            this.date_str = FormatDate(this.post);
          });
        },

        imageLoaded(instance, image) {
          let img_pos = image.img.getBoundingClientRect();
          if (this.$refs.featured_caption) this.$refs.featured_caption.style.width = `${img_pos.width}px`;
        },

    },
}
</script>
<style lang="scss">
  .post-header {
    padding: 0 0 var(--padding);
    text-align: center;
    max-width: 65vw;
    margin: auto;

    h2 {
      font-size: var(--title-size);
      margin: 0 0 1rem;
      line-height: 1.05;
    }

    .ui-button {
      min-width: 18rem;
      margin: 2rem 0 1rem;
    }
  }

  .post-wrap {
    & > .inner > .image {
      display: block;
      margin: 0 0 var(--padding-x2);

      img {
        display: block;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 80vh;
        margin: auto;
      }

      figcaption {
        font-size: var(--small-size);
        margin: auto;
        margin-top: var(--padding-50);
      }
    }

    .image.featured-image {
      margin-left: -12rem;
      width: calc(100% + 24rem);
    }

    .ui-button {
      min-width: 18rem;
      margin: 2rem auto 1rem;
      text-align: center;
    }

    .buy-wrapper {
      width: 100%;
      text-align: center;
      margin-bottom: var(--padding);
    }

    .slideshow-block .swiper-container {
      background: white;
    }
  }

  @media only screen and (max-width: 767px) {
    .post-wrap {
      .image.featured-image {
          margin-left: 0;
          width: auto;
      }
      .image figcaption {
          font-size: var(--tiny-size);
          line-height: 1.2;
      }
    }
  }
</style>

